import { useI18nStore } from './i18n.store';

/**
 * The language to render in.
 *
 * A surface-scoped `override` wins over the account language when one is set — see the store.
 * It is `null` on every screen but the candidate-facing intake pages, so everywhere else this
 * returns exactly what it always did.
 */
export const useLanguage = () => {
  return useI18nStore((s) => s.override ?? s.language);
};

export const getLanguage = () => {
  const { override, language } = useI18nStore.getState();

  return override ?? language;
};
